export class Me {
  constructor(
    id,
    email,
    roles,
    permissions,
    isHumanResources = null,
    name = null,
    firstSurname = null,
    secondSurname = null,
    shortName = null,
    avatar = null,
  ) {
    this.id = id;
    this.email = email;
    this.roles = roles;
    this.permissions = permissions;
    this.isHumanResources = isHumanResources;
    this.name = name;
    this.firstSurname = firstSurname;
    this.secondSurname = secondSurname;
    this.shortName = shortName;
    this.avatar = avatar;
  }
  static createFromResponseData(data) {
    const me = new Me(
      data.id,
      data.email,
      data.roles,
      data.permissions,
      data.isHumanResources ?? null,
      data.name ?? null,
      data.firstSurname ?? null,
      data.secondSurname ?? null,
      data.shortName ?? null,
      data.avatar ?? null,
    );
    return Object.assign(me, data);
  }
};